module.exports = __webpack_public_path__ + "img/cta_google.cde89955.png";